<template>
  <div>
    <breadcrumb
      main-name="点位详情"
      :breadcrumbList="breadcrumbList"
    ></breadcrumb>
    <div class="content-wrap">
      <a-descriptions
        title="地理位置"
        size="middle"
        layout="horizontal"
        :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
      >
        <a-descriptions-item label="省市区">
          {{
            `${detailInfo.provinceName || ''}-${detailInfo.cityName || ''}-${
              detailInfo.districtName || ''
            }`
          }}
        </a-descriptions-item>
        <a-descriptions-item label="网点资源">
          {{ detailInfo.networkName || '' }}
        </a-descriptions-item>
        <a-descriptions-item label="点位名称">
          {{ detailInfo.name || '' }}
        </a-descriptions-item>
        <a-descriptions-item label="场景">
          {{ detailInfo.buildingType || '' }}
        </a-descriptions-item>
        <a-descriptions-item label="经纬度">
          {{
            (detailInfo.latitude || '*') + ',' + (detailInfo.longitude || '*')
          }}
        </a-descriptions-item>
        <a-descriptions-item label="详细地址">{{
          detailInfo.address
        }}</a-descriptions-item>
      </a-descriptions>
      <a-descriptions
        title="设备信息"
        size="middle"
        layout="horizontal"
        :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
      >
        <a-descriptions-item label="媒体型号">{{
          detailInfo.deviceModelName || ''
        }}</a-descriptions-item>
        <a-descriptions-item label="屏幕类型">
          {{ detailInfo.mediaTypeName || '' }}
        </a-descriptions-item>
        <a-descriptions-item label="MAC">{{
          detailInfo.deviceId
        }}</a-descriptions-item>
        <a-descriptions-item label="点位ID">{{
          detailInfo.id
        }}</a-descriptions-item>
        <a-descriptions-item label="开机时间">
          {{ detailInfo.bootTime }}
        </a-descriptions-item>
        <a-descriptions-item label="关机时间">
          {{ detailInfo.shutDownTime }}
        </a-descriptions-item>
        <a-descriptions-item label="屏幕尺寸">
          {{ detailInfo.screenSize ? detailInfo.screenSize + '英寸' : '' }}
        </a-descriptions-item>
        <a-descriptions-item label="屏幕分辩率">
          {{ `${detailInfo.width || ''}*${detailInfo.height || ''}px` }}
        </a-descriptions-item>
        <a-descriptions-item label="是否有声音">
          {{ detailInfo.hasVoice ? '是' : '否' }}
        </a-descriptions-item>
        <a-descriptions-item label="是否联网">
          {{ detailInfo.hasInternet ? '是' : '否' }}
        </a-descriptions-item>
        <a-descriptions-item label="联网方式">
          {{ detailInfo.internetModel }}
        </a-descriptions-item>
        <a-descriptions-item label="归属公司">
          {{ detailInfo.companyName || '' }}
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions
        title="广告信息"
        size="middle"
        layout="horizontal"
        :column="{ xxl: 4, xl: 3, lg: 3, md: 3, sm: 2, xs: 1 }"
      >
        <a-descriptions-item label="上刊类型">
          {{ detailInfo.publishTypeName || '' }}
        </a-descriptions-item>
        <a-descriptions-item label="监播方式">
          {{ (detailInfo.watchModeName || []).join(';') }}
          <span
            class="cursor-active"
            @click="adMonitorConfig"
          >修改</span>
        </a-descriptions-item>
        <a-descriptions-item label="屏幕高峰时段">
          {{
            (detailInfo.peakStartTime || '') +
            '~' +
            (detailInfo.peakEndTime || '')
          }}
        </a-descriptions-item>
        <a-descriptions-item
          v-if="sessionData.userType === 1"
          label="广告设置"
        >
          <span
            class="cursor-active"
            @click="adConfig"
          >点击设置</span>
        </a-descriptions-item>
        <a-descriptions-item
          v-if="
            sessionData.userType === 6 &&
            detailInfo.deviceModelName != 'QLG2020-R8'
          "
          label="C端价格设置"
        >
          <span
            class="cursor-active"
            @click="PriceOption"
          >点击设置</span>
        </a-descriptions-item>
      </a-descriptions>
    </div>
    <!-- c端价格设置 -->
    <a-modal
      title="价格设置"
      :visible="PriceVisible"
      @ok="PriceHandleOk"
      okText="保存"
      width="400px"
      @cancel="SetPriceOff"
    >
      <div>
        <div class="priceTitle">
          <p
            v-for="(item, index) in setPriceTitleList"
            :key="index"
            :class="{ addLineClore: setPriceTitleColor == index }"
            @click="selectOption(index)"
          >
            {{ item }}
          </p>
        </div>
        <a-table
          size="middle"
          :pagination="false"
          :columns="SetPriceColumns"
          :data-source="SetPriceData"
          bordered
        >
          <template
            slot="priceDay"
            slot-scope="row"
          >
            <div class="setPriceStep">
              <div class="timePrice">{{ row.priceDay + row.unitType }}</div>
              <a-input-number
                :default-value="row.discount || 0"
                :min="0"
                :max="100"
                :formatter="(value) => `${value}%`"
                :parser="(value) => value.replace('%', '')"
                @change="(value) => changePriceDay(value, row)"
                :step="1"
              /><span>折</span>
            </div>
          </template>
        </a-table>
      </div>
    </a-modal>
    <!-- 广告点位起投价格设置 -->
    <a-modal
      title="广告设置"
      :width="384"
      wrapClassName="ad-config-modal"
      :visible="adConfigModal"
      :confirm-loading="confirmLoading"
      @ok="commitConfig"
      @cancel="cancelAdHandler"
      :okText="isEdit?'保存':'编辑'"
    >
    <!-- tab切换栏 -->
      <div class="ad-radio-wrap">
        <a-radio-group v-model="activeRadio">
          <a-radio-button
            v-for="(item, index) in spaceList"
            :key="index"
            :value="index"
            @click="clickButton(index)"
          >
            {{ item.spaceName }}
          </a-radio-button>
        </a-radio-group>
      </div>
      <div
        v-if="currentSpaceId == 1"
        class="source-percent"
      >
        <div class="alert_wrapper" v-show="!isEdit">
          <a-alert 
            :message="'归属公司自留比例 : '+spaceList[activeRadio].seconds" 
            type="info" 
            show-icon />
        </div>
        <div v-show="isEdit" class="proportion_select_wrapper">
          <span
            class="label"
            style="flex-grow: 0"
          >归属公司自留比例 : &nbsp
          </span>
          <a-select
            size="default"
            v-model="editSeconds"
          >
            <a-select-option
              v-for="(item, index) in percentObj"
              :key="index*1"
              :value="item"
            >
              {{ item }}
            </a-select-option>
          </a-select>
        </div>
      </div>
      <!-- 如果选择的是大屏轮播广告 -->
      <div class="deliveryPeriod" v-show="currentSpaceId ==1">黄金时段</div>
       <a-table
        v-show="currentSpaceId ==1"
        rowKey="specificationId"
        :pagination="false"
        :columns="specificationColumns"
        :data-source="spaceList[activeRadio].deliveryPeriodSpecifications"
        bordered
      >
        <template
          slot="priceWeek"
          slot-scope="row"
        >
          <div  v-show="isEdit" >
             <a-input-number
              class="sufInput"
              :default-value="row.editPriceWeek || 0"
              :min="0"
              :max="9999"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
              @change="(value) => changePriceWeek(value, row)"
            />
            <div  class="u-suf">{{row.unitType}}</div>
          </div>
          
          <div v-show="!isEdit">{{row.priceWeek}}元/周</div>
        </template>
        
      </a-table>
       <div class="deliveryPeriod" v-show="currentSpaceId ==1">普通时段</div>
       <a-table
        v-show="currentSpaceId ==1"
        rowKey="specificationId"
        :pagination="false"
        :columns="specificationColumns"
        :data-source="spaceList[activeRadio].commonSpecifications"
        bordered
      >
        <template
          slot="priceWeek"
          slot-scope="row"
        >
          <div  v-show="isEdit" >
             <a-input-number
              class="sufInput"
              :default-value="row.editPriceWeek || 0"
              :min="0"
              :max="9999"
              :formatter="
                (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              "
              :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
              @change="(value) => changePriceWeek(value, row)"
            />
            <div  class="u-suf">{{row.unitType}}</div>
          </div>
          
          <div v-show="!isEdit">{{row.priceWeek}}元/周</div>
        </template>
        
      </a-table>
      <!-- 如果选择的不是大屏轮播广告 -->
      <a-table
        v-if="currentSpaceId != 1"
        style="margin: 24px 0 0"
        rowKey="specificationId"
        :pagination="false"
        :columns="specificationColumns"
        :data-source="spaceList[activeRadio].specifications"
      >
        <template
          slot="priceWeek"
          slot-scope="row"
        >
          <div  v-show="isEdit" >
            <a-input-number
            class="sufInput"
            :default-value="row.editPriceWeek || 0"
            :min="0"
            :max="9999"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\$\s?|(,*)/g, '')"
            @change="(value) => changePriceWeek(value, row)"
          />
           <div  class="u-suf">{{row.unitType}}</div>
          </div>
          <div v-show="!isEdit">{{row.priceWeek}}元/周</div>
        </template>
      </a-table>
    </a-modal>
    <!-- 设置监播方式 -->
    <a-modal
      title="监播方式"
      wrapClassName="switch-status-modal"
      width="260px"
      :visible="adMonitorModal"
      :confirm-loading="adMonitorLoading"
      :closable="false"
      @ok="adMonitorFun"
      @cancel="adMonitorModal = false"
    >
      <a-checkbox-group
        v-model="monitorCheckedList"
        :options="monitorOptions"
      />
    </a-modal>
  </div>
</template>

<script>
import breadcrumb from '../common/Breadcrumb.vue';
import api from '../../commomFun/api.js';
import priceFormat from '../../commomFun/priceFormat';
import moment from 'moment';
export default {
  name: 'mediaDetail',
  components: {
    breadcrumb
  },
  data () {
    return {
      aaa: '',
      allTable: [], //整合之后的数组
      setPriceTitleColor: 0, //选中某个
      setPriceTitleList: ['大屏轮播广告'],
      PriceVisible: false, //设置价格的弹窗
      SetPriceData: [],
      SetPriceColumns: [
        {
          title: '规格',
          dataIndex: 'playSeconds',
          width: 100,
          customRender: (text, record, index) => {
            return text + '秒/300次';
          }
        },
        {
          title: '价格',
          key: 'priceDay',
          ellipsis: true,
          width: 130,
          scopedSlots: {
            customRender: 'priceDay'
          }
        }
      ],
      sessionData: JSON.parse(sessionStorage.getItem('userInfo')),
      // 面包屑
      breadcrumbList: [
        {
          name: '点位管理',
          path: '/mediaList'
        },
        {
          name: '点位详情',
          path: '/mediaDetail'
        }
      ],
      pointId: '',
      detailInfo: {},
      // 广告设置
      confirmLoading: false,
      adConfigModal: false,
      spaceList: [{ specifications: [] }],
      specificationColumns: [
        {
          title: '秒数规格',
          key: 'playSeconds',
          dataIndex: 'playSeconds',
          customRender: (text, record, index) => {
            console.log(text, record, index,'text, record, index');
            return (text + '秒/' + record.playCount + '次');
          },
          width: 100,
          ellipsis: true,
          align:'left',
        },
        {
          title: '价格',
          key: 'priceWeek',
          scopedSlots: { customRender: 'priceWeek' },
          width: 100,
          ellipsis: true,
          align:'left',
        }
      ],
      percentObj: [
         '0%',
         '5%',
         '10%',
         '15%',
         '20%',
         '25%',
         '30%',
         '35%',
         '40%',
         '45%',
         '50%',
         '55%',
         '60%',
         '65%',
         '70%',
         '75%',
         '80%',
         '85%',
         '90%',
         '95%',
         '100%'
      ],
      adMonitorModal: false,
      adMonitorLoading: false,
      monitorOptions: [
        { label: '程序截屏', value: '1' },
        { label: '人工拍照', value: '2', disabled: true }
      ],
      monitorCheckedList: ['2'],
      activeRadio: 0,
      isEdit:false, //是否是编辑状态
      editSeconds:'' ,//编辑时期切换比例,为保存时候不会改变预览界面的值
    };
  },
  computed: {
    currentSpaceId () {
      return this.spaceList[this.activeRadio * 1].spaceId;
    }
  },
  methods: {
    moverTar (className, sonTar, width = 20, index) {
      /**移动标签位置
       *@param className 父级class
       *@param sonTar 子标签
       *@param width 每次移动的宽度
       *@param index 当前标签点击的位置
       **/
      let div = document.getElementsByClassName(className)[0];
      let pWidth = div.getElementsByTagName(sonTar)[index].clientWidth + width;
      div.scrollLeft = pWidth * index;
    },
    //点击广告设置tab切换
    clickButton (index) {
      // 点击会修改this.activeRadio的值相应的currentSpaceId也会改变
      this.moverTar('ant-radio-group', 'label', 20, index);
    },
    //c端设置价格切换广告类型
    selectOption (index) {
      if (index == this.setPriceTitleColor) return;
      this.moverTar('priceTitle', 'p', 20, index);
      this.setPriceTitleColor = index;
      this.SetPriceData = this.allTable[index].specifications;
    },
    //点击设置价格，打开弹窗的时候去请求数据
    PriceOption () {
      let parmas = {
        pointId: this.pointId
      };
      api
        .getApiSpecil('platform/point/getClientAdSpaceListByPointId', parmas)
        .then((res) => {
          //动态加上key
          res.data.data.forEach((item, f) => {
            item.specifications.forEach((v, index) => {
              v.key = f + '-' + index;
            });
          }, []);
          this.allTable = res.data.data;
          //拿到一共多少个广告类型，进行切换
          this.setPriceTitleList = this.allTable.map((item) => {
            return item.spaceName;
          }, []);
          //默认去拿第一个产品规格
          this.SetPriceData = this.allTable[0].specifications;
        });
      this.PriceVisible = true;
    },
    //c端设置价格关闭弹窗
    SetPriceOff () {
      this.setPriceTitleColor = 0;
      this.PriceVisible = false;
    },
    //c端修改价格
    PriceHandleOk () {
      let sendData = this.allTable[this.setPriceTitleColor];
      sendData.specifications.forEach((item) => {
        if (item.key) {
          delete item.key;
        }
      });
      sendData.pointId = this.pointId;
      api
        .postApiSpecil(
          '/platform/point/updateClientSpecificationByPointId',
          sendData
        )
        .then((res) => {
          this.PriceVisible = false;
          this.setPriceTitleColor = 0;
          if (res.data.code == 200) {
            this.$message.success('保存成功！');
          } else {
            this.$message.error('系统错误');
          }
        });
    },
    //c端修改折扣
    changePriceDay (val, row) {
      row.discount = val * 1;
    },
    moment,
    // 广告设置弹框
    adConfig () {
      this.confirmLoading = false;
      this.isEdit = false;
      api
        .getApiSpecil('/platform/point/getAdSpaceListByPointId', {
          pointId: this.pointId
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.spaceList = res.data.data || [];
            if (this.spaceList.length > 0) {
              this.activeRadio = 0;
              this.spaceList[this.activeRadio].seconds += '%'
              this.editSeconds =  this.spaceList[this.activeRadio].seconds 
              //对数据进行处理，一个是实际值一个是编辑值
              for (let i = 0; i < this.spaceList.length; i++) {
                this.spaceList[i].commonSpecifications.forEach (item=>{
                  item.editPriceWeek = item.priceWeek
                })
                this.spaceList[i].deliveryPeriodSpecifications.forEach (item=>{
                   item.editPriceWeek = item.priceWeek
                })
                 this.spaceList[i].specifications.forEach (item=>{
                   item.editPriceWeek = item.priceWeek
                })
              }

              this.adConfigModal = true;
            } else {
              this.$message.warning('暂无数据！');
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 广告设置修改广告单价
    changePriceWeek (val, row) {
      row.editPriceWeek = val * 1;
    },
    // 提交广告设置
    commitConfig () {
      //判断现在是编辑状态还是浏览状态
      if (!this.isEdit) {
         this.isEdit = true;
      }else{
        this.confirmLoading = true;
        //应后端要求去除百分号，返回的数据没有百分号，在获取的时候添加了
        this.spaceList[this.activeRadio].seconds = this.editSeconds
        this.spaceList[this.activeRadio].seconds = this.spaceList[this.activeRadio].seconds.split('%')[0];
        //删除编辑价格
        for (let i = 0; i < this.spaceList.length; i++) {
                this.spaceList[i].commonSpecifications.forEach (item=>{
                  item.priceWeek = item.editPriceWeek
                  delete item.editPriceWeek
                })
                this.spaceList[i].deliveryPeriodSpecifications.forEach (item=>{
                  item.priceWeek = item.editPriceWeek
                  delete item.editPriceWeek
                })
                 this.spaceList[i].specifications.forEach (item=>{
                  item.priceWeek = item.editPriceWeek
                  delete item.editPriceWeek
                })
              }
        let params = this.spaceList[this.activeRadio];
        params.pointId = this.pointId;
        //   params.companyId = this.detailInfo.companyId; //提交的公司id 待定
        //   params.clientDiscount = ''; // c端折扣 如果是平台价格不用传入后续会加  待定
        //   params.channe = 0; //渠道0-平台 1-c端 待定
        params.specifications.forEach((item) => {
          item.priceWeek = item.priceWeek || 0;
        });
        if (this.currentSpaceId > 1 && params.seconds === null) {
          params.seconds = 180;
        }

        if (params.specifications.length > 0) {
          api
            .postApiSpecil('/platform/point/updateSpecificationByPointId', params)
            .then((res) => {
              if (res.data.code == 200) {
                this.confirmLoading = false;
                this.adConfigModal = false;
                this.$message.success(res.data.msg);
              } else {
                this.$message.error(res.data.msg);
              }
            });
        }
      }
      
    },
    cancelAdHandler(){
      if (this.isEdit) {
        this.isEdit = false;
      }else{
        this.adConfigModal = false
      }
    },
    // 监播方式弹框
    adMonitorConfig () {
      this.adMonitorModal = true;
      this.adMonitorLoading = false;
    },
    // 提交监播方式
    adMonitorFun () {
      // 1 程序截屏,2 人工拍照
      this.adMonitorLoading = true;
      api
        .postApiSpecil('/platform/point/updateWatchMode', {
          pointId: this.pointId,
          modeIds: this.monitorCheckedList
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.msg);
            this.adMonitorLoading = false;
            this.adMonitorModal = false;
            this.getMediaDetail();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    getParams () {
      this.pointId = this.$route.query.pointId;
    },
    //获取媒体详情
    getMediaDetail () {
      let pointId = this.pointId;
      api
        .getApiSpecil('/platform/point/getPointDetail?pointId=' + this.pointId)
        .then((res) => {
          console.log(
            '这里拿到一个companyId，然后再设置的时候，点确定把这个id发出去'
          );
          if (res.data.code == 200) {
            this.detailInfo = res.data.data;
            this.monitorCheckedList = (this.detailInfo.watchMode || '').split(
              ','
            );
          } else {
            this.$message.error(res.data.msg);
          }
        });
    }
  },
  mounted () {
    this.getParams();
    this.getMediaDetail();
  }
};
</script>

<style scoped lang="scss">
.sufInput {
  float: left;
  border-radius: 4px 0 0 4px;
  width: 65px;
  /deep/ .ant-input-number-handler-wrap{
    display:none;
  }
  /deep/ .ant-input-number-input-wrap {
    display: inline-block;
    .ant-input-number-input{
      padding: 0 0 0 12px;
    }
  }
  /* &::after {
    padding: 6px 6px;
    box-sizing: border-box;
    background: #f7f7f7;
    border-radius: 0px 4px 4px 0px;
    border: 1px solid #d9d9d9;
  } */
}
/deep/ .switch-status-modal {
  .ant-modal-header {
    padding: 10px 16px 12px;
  }
  .ant-modal-body {
    padding: 18px 16px;
  }
  .ant-modal-footer {
    border: none;
  }
}
/deep/ .ad-config-modal {
  .ant-modal-header{
    box-sizing: border-box;
    height:54px
  }
  .ant-modal-footer{
    box-sizing: border-box;
    height:54px
  }
  .ant-modal-close-x{
    line-height: 34px;
  }
  .ant-table table{
    border-radius: 4px;
  }
  .ant-modal-body {
    padding: 24px 32px;
  }
  .ad-radio-wrap {
    // height: 32px;
    // overflow-x: scroll;
    display: flex;
    justify-content:center
  }
  .ant-radio-group {
    // width: 100%;
    white-space: nowrap;
    overflow-x: auto;
  }
  .source-percent {
    display: flex;
    align-items: center;
    height:40px;
    width:320px;
    margin: 20px 0 4px;
    .ant-select {
      width: 194px;
    }
  }
  // .ant-input-number {
  //   ::after {
  //   }
  // }
  .ant-table-thead > tr > th,
  .ant-table-tbody > tr > td{
    padding:12px 8px ;
    box-sizing: border-box;
    width: 175px;
  }
//调整 起投价格行高
  .ant-table-tbody > tr > td:nth-child(2){
    padding: 6px 21px 8px 8px;
  }
}
.content-wrap {
  flex-direction: column;
  margin: 24px;
  padding: 24px 32px 8px;
  background: #fff;
  /deep/ .ant-descriptions {
    margin-bottom: 16px;
    border-bottom: 1px solid #e9e9e9;
    &:last-child {
      margin-bottom: 0;
      border: none;
    }
    .ant-descriptions-title {
      margin-bottom: 16px;
    }
    .ant-descriptions-item {
      padding-bottom: 16px;
      .ant-descriptions-item-label {
      }
      .ant-descriptions-item-content {
      }
    }
  }
  .cursor-active {
    color: #188fff;
    cursor: pointer;
  }
}
.priceTitle {
  display: flex;
  margin-bottom: 20px;
  border-bottom: 2px solid rgb(235, 235, 235);
  justify-content: space-between;
  padding: 0 10px;
  overflow-x: scroll;
  white-space: nowrap;

  p {
    margin: 0 10px;
    cursor: pointer;
    text-align: center;
    padding-bottom: 10px;
  }
  .addLineClore {
    border-bottom: 2px solid rgb(16, 142, 233);
    color: rgb(16, 142, 233);
  }
}
.setPriceStep {
  display: flex;
  align-items: center;
  text-align: center;
  .timePrice {
    margin-right: 10px;
  }
  span {
    display: inline-block;
    background: rgb(235, 235, 235);
    border-radius: 0 5px 5px 0px;
    color: rgb(152, 152, 152);
    line-height: 32px;
    width: 30px;
  }
}
::-webkit-scrollbar {
  display: none;
}
.u-suf {
  float: left;
  height: 32px;
  line-height: 20px;
  padding: 6px 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background: #f7f7f7;
  border-radius: 0px 4px 4px 0px;
  border: 1px solid #d9d9d9;
  border-left: none;
}
// 时段标题样式
.deliveryPeriod{
  width: 64px;
  height: 54px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.85);
  line-height: 54px;
}
//警告框外层容器样式
.alert_wrapper{
  // margin-bottom: 3px;
  height:40px;
  width: 100%;
}
.proportion_select_wrapper{
  width: 320px;
}

</style>